import axios from "axios";
import { AppResponse } from "../models/Response";
import { Util } from "../Util";

export interface CopaymentResponse {
  success: boolean;
  data?: {
    copayment?: {
      status?: string;
      amount?: number;
      details?: string;
    };
  };
  message?: string;
  error?: string;
}

export class CopaymentService {
  /**
   * Process client copayment
   * @param {string} clientId - Client ID
   * @param {number} copayment - Copayment amount
   * @param {string} vonageSessionId - Vonage session ID to link with the payment
   * @returns {Promise<CopaymentResponse>} - Payment processing result
   */
  static async processClientCopayment(
    clientId: string, 
    copayment: number, 
    vonageSessionId: string
  ): Promise<CopaymentResponse> {
    const url = Util.apiAuthUrl("pay-copayment");
    
    const data = {
      clientId,
      copayment,
      vonageSessionId
    };
    
    return await axios.post(url, data);
  }
  
  /**
   * Get client copayment information
   * @param {string} clientId - Client ID
   * @returns {Promise<CopaymentResponse>} - Copayment information
   */
  static async getClientCopayment(clientId: string): Promise<CopaymentResponse> {
    // const url = Util.apiAuthUrl("get-copayment");
    
    // const params = {
    //   client_id: clientId
    // };
    
    // return await axios.get(url, { params });

    const url = Util.apiAuthUrl("client-copayment-amount");
    return await axios.get(url);

    
  }
  
  /**
   * Check payment status of a meeting
   * @param {string} vonageSessionId - Vonage session ID of the meeting
   * @returns {Promise<CopaymentResponse>} - Payment status information
   */
  static async getMeetingCopaymentStatus(vonageSessionId: string): Promise<CopaymentResponse> {
    const url = Util.apiAuthUrl("get-copayment-status-of-a-meeting");
    
    const data = {
      vonageSessionId
    };
    
    return await axios.post(url, data);
  }

  /**
   * Get copayment information of the most recent meeting
   * @returns {Promise<CopaymentResponse>} - Payment status information
   */
  static async getRecentMeetingCopayment(): Promise<CopaymentResponse> {
    const url = Util.apiAuthUrl("get-recent-meeting-copayment");
    return await axios.post(url);
  }

  /**
   * Get the latest copayment information of the client
   * @returns {Promise<any>} - Time and amount information of the latest copayment
   */
  static async getLastCopaymentInfo(): Promise<any> {
    const url = Util.apiAuthUrl("client-last-copayment-info");
    return await axios.get(url);
  }
} 